import React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'styled-tools';
import heroBackground from 'assets/images/HeroBackground.png';
import SiteMessages from '../SiteMessages';
import PropTypes from 'prop-types';

const HeroSection = styled.div`
  font-family: ${theme('fonts.title')};
  font-size: 1.5rem;
  font-weight: 700;
  background-image: url(${heroBackground});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: ${theme('colors.white')};
  padding: 1.5rem;
  text-align: center;
  width: 100%;

  h1 {
    font-size: 1em;
  }
`;

export const HeroSectionSubtitle = styled.div`
  font-family: ${theme('fonts.heading')};
  font-size: 1rem;
`;

function HeroWrapper({ children }) {
  return (
    <>
      <HeroSection>{children}</HeroSection>
      <SiteMessages />
    </>
  );
}

HeroWrapper.propTypes = {
  children: PropTypes.element,
};
HeroWrapper.defaultProps = {};

export default HeroWrapper;
